// services/admin.doctor.service.js
import ApiService from './api.service';

const AdminDoctorService = {
    uploadProfilePicture: async (doctorId, file) => {
        // Verifica la dimensione qui come ulteriore precauzione
        const maxSize = 1 * 1024 * 1024; // 2MB
        if (file.size > maxSize) {
          throw new Error("413: File too large");
        }
        
        const formData = new FormData();
        formData.append('profile_picture', file);
        
        try {
          return await ApiService.fetch(`admin/doctors/${doctorId}/profile-picture`, {
            method: 'POST',
            body: formData,
            headers: {}
          });
        } catch (error) {
          // Se l'errore è 413, trasforma in un messaggio più descrittivo
          if (error.message && (error.message.includes('413') || error.status === 413)) {
            throw new Error("413: L'immagine è troppo grande. La dimensione massima consentita è 2MB.");
          }
          throw error;
        }
      },

    updatePassword: (doctorId, passwordData) => {
        return ApiService.fetch(`admin/doctors/${doctorId}/password`, {
            method: 'PUT',
            body: JSON.stringify({
                new_password: passwordData.new_password
            })
        });
    },

    getProfile: (doctorId) => {
        console.log('[DEBUG] Getting profile for doctor:', doctorId);
        return ApiService.fetch(`admin/doctors/${doctorId}/profile`)
            .then(response => {
                console.log('[DEBUG] Profile response:', response);
                return response;
            })
            .catch(error => {
                console.error('[DEBUG] Error getting profile:', error);
                throw error;
            });
    },

    updateProfile: (doctorId, data) =>
        ApiService.fetch(`admin/doctors/${doctorId}/profile`, {
            method: 'PUT',
            body: JSON.stringify({
                ...data,
                phone: data.phone
            })
        }),

    // Servizi del professionista
    getServices: (doctorId) =>
        ApiService.fetch(`admin/doctors/${doctorId}/services`),

    createService: (doctorId, serviceData) =>
        ApiService.fetch(`admin/doctors/${doctorId}/services`, {
            method: 'POST',
            body: JSON.stringify(serviceData)
        }),

    updateService: (doctorId, serviceId, data) =>
        ApiService.fetch(`admin/doctors/${doctorId}/services/${serviceId}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        }),

    deleteService: (doctorId, serviceId) =>
        ApiService.fetch(`admin/doctors/${doctorId}/services/${serviceId}`, {
            method: 'DELETE'
        }),

    // Aggiungi questi metodi a admin.doctor.service.js
    getAllTags: () =>
        ApiService.fetch('admin/tags'),

    // Nel service admin
        assignTag: (doctorId, tagId) => {
            console.log('Assigning tag:', { doctorId, tagId }); // Debug
            return ApiService.fetch('admin/doctors/tags/assign', {
                method: 'POST',
                body: JSON.stringify({
                    therapist_id: doctorId,
                    tag_id: tagId
                })
            });
        },

    removeTag: (doctorId, tagId) =>
        ApiService.fetch('admin/doctors/tags/remove', {
            method: 'POST',
            body: JSON.stringify({
                therapist_id: doctorId,
                tag_id: tagId
            })
        }),

        addDefaultServices: async (userId) => {
            try {
                const response = await ApiService.fetch(`admin/doctors/${userId}/default-services`, {
                    method: 'POST'
                });
                return response;
            } catch (error) {
                console.error('[DEBUG] Error adding default services:', error);
                throw error;
            }
        }
};

export default AdminDoctorService;